import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslate } from '@repo/unicity'
import type { TaiwanDuplicateOrderResponse } from '../../../types/taiwan.types'

// Warns when the payment router reports a recent identical order for this UUID.
// The customer can proceed (place anyway) or cancel.
export default function DuplicateOrderDialog({
    duplicate,
    submitting,
    onProceed,
    onCancel
}: {
    duplicate: TaiwanDuplicateOrderResponse | null
    submitting: boolean
    onProceed: () => void
    onCancel: () => void
}) {
    const { translate } = useTranslate()

    return (
        <Dialog
            open={!!duplicate}
            onClose={() => !submitting && onCancel()}
            PaperProps={{ sx: { borderRadius: 3, px: 1 } }}
            data-testid="taiwan-payment-duplicate-dialog">
            <DialogTitle sx={{ fontWeight: 700, color: '#003764' }} data-testid="taiwan-payment-duplicate-title">
                {translate('duplicate_order')}
            </DialogTitle>
            <DialogContent data-testid="taiwan-payment-duplicate-content">
                <DialogContentText data-testid="taiwan-payment-duplicate-text">{translate('duplicate_order_detected')}</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }} data-testid="taiwan-payment-duplicate-actions">
                <Button onClick={onCancel} disabled={submitting} sx={{ color: '#5A8FC3' }} data-testid="taiwan-payment-duplicate-cancel">
                    {translate('cancel')}
                </Button>
                <Button
                    onClick={onProceed}
                    variant="contained"
                    disabled={submitting}
                    startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : undefined}
                    data-testid="taiwan-payment-duplicate-proceed">
                    {translate('proceed_to_payment')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
